import { z } from 'zod';

import { ORGANIZATION_STATUS } from '../enums';

import { emailSchema, idSchema, slugSchema } from './common';

export const organizationSummarySchema = z.object({
  id: idSchema,
  name: z.string(),
  slug: slugSchema,
  status: z.enum([ORGANIZATION_STATUS.ACTIVE, ORGANIZATION_STATUS.SUSPENDED]),
  memberCount: z.number().int().nonnegative(),
  projectCount: z.number().int().nonnegative(),
  createdAt: z.string(),
});
export type OrganizationSummary = z.infer<typeof organizationSummarySchema>;

export const createOrganizationInputSchema = z.object({
  name: z.string().trim().min(2).max(80),
  slug: slugSchema,
  adminEmail: emailSchema,
  adminName: z.string().trim().min(1).max(120),
});
export type CreateOrganizationInput = z.infer<typeof createOrganizationInputSchema>;

export const updateOrganizationInputSchema = z.object({
  name: z.string().trim().min(2).max(80).optional(),
  logoUrl: z.string().url().nullable().optional(),
  timezone: z.string().min(1).max(64).optional(),
});
export type UpdateOrganizationInput = z.infer<typeof updateOrganizationInputSchema>;

export const organizationStatusInputSchema = z.object({
  status: z.enum([ORGANIZATION_STATUS.ACTIVE, ORGANIZATION_STATUS.SUSPENDED]),
});
export type OrganizationStatusInput = z.infer<typeof organizationStatusInputSchema>;
